import React from 'react';
import {
  OpenStreetMap,
  visitsToMarkers,
} from '../../../../../shared/library/map';
import type { http_VisitItem } from '../../../../../services/url-shortener';

type MapTabProps = {
  visits: http_VisitItem[];
};

export const MapTab: React.FC<MapTabProps> = ({ visits }) => {
  const markers = React.useMemo(() => {
    return visitsToMarkers(visits || []);
  }, [visits]);

  return (
    <div className="space-y-4 w-full">
      <div className="grid grid-cols-1 gap-4 w-full">
        <OpenStreetMap markers={markers} height="500px" className="w-full" />
      </div>
    </div>
  );
};
